import {
    SET_SUBJECT,
    SET_CLASS,
    SET_TEACHER,
    SET_START_TIME,
    SET_END_TIME,
    SET_START_DATE,
    SET_END_DATE,
    SET_MODE,
    SET_WEEKDAYS,
    GET_SUB_LIST,
    GET_CLASS_LIST,
    GET_TEACHER_LIST,
    GET_SCHEDULE_LIST,
    GET_SUMMARY_DATA,
    GET_TIMETABLE_DATA,
    GET_STD_LIST_FILTER,
    SET_STD_FILTER,
    GET_TODAY_ACTIVITIES_DATA,
    GET_SUB_LIST_FILTER,
    SET_SCHEDULE_ID,
    SET_SCHEDULE_TIMETABLE,
    SET_MONTH_OR_WEEK,
    SET_START_DATE_SCHEDULE,
    SET_END_DATE_SCHEDULE,
    SET_TAB_TYPE,
    SET_STD_FILTER_TIMETABLE,
    UPDATE_ERROR,
    SET_BROADCAST_SELECTED_CLASSROOM,
    SET_ROOM_IDS,
    GET_ONLINE_USER,
    SET_ACCESS,
    SET_DEL_OR_CANCEL,
    UPDATE_BROADCAST_STUDENT_LIST,
    SET_CURRENT_DATE,
    GET_MODES,
    SET_TEACHER_FILTER,
    SET_CLASS_FILTER,
    SET_SUB_FILTER,
    SET_JOIN_LOADER,
    SET_STUDENT_DATA,
    SET_SUBJECT_DATA,
    SET_SELECTED_STUDENTS_CLEAR,
    SET_STUDENT_LIST_LOADING,
    SET_SELECTED_STUDENTS,
    SET_SELECT_ALL,
    SET_CHECKBOX_STATE,
    SET_SELECTED_ID,
    SET_PRESENT_STUDENTS,
    SET_CARD_DATA,
    SET_ALL_FALSE,
    SET_ATTENDANCE_THRESHOLD,
    SET_INITIAL_SUMMARY,
    SET_TEACHER_DATE,
    SET_PAGE_TOGGLE,
    FETCH_SUBSALERT_DATA,
    UPDATE_ACTIVE_CLASS,
    SET_CONFERENCE_JOIN_LOADER,
    STUDENT_STANDARD_FILTER,
    SET_RECORD_COUNT,
    SET_LIVE_STREAM_URL,
    SET_SUBSCRIPTION_MODAL,
    DRAWER_BOOLEAN_STATE
} from '../actions/schedule';

const initialState = {
    subId: null,
    classId: [],
    teacherId: null,
    startTime: '',
    endTime: '',
    startDate: '',
    endDate: '',
    mode: '',
    weekdays: [],
    subList: [],
    classList: [],
    teacherList: [],
    scheduleList: {},
    summaryDataList: [],
    timetableDataList: [],
    stdListFilter: [],
    stdIdFilter: null,
    todayActivities: {},
    subListFilter: [],
    scheduleId: null,
    timetableItem: {},
    isMonthOrWeek: 'week',
    startDateSummary: '',
    endDateSummary: '',
    tabType: 'schedule',
    stdTimetable: null,
    errorMessage: {},
    broadcastSelectedClass: [],
    roomIds: [],
    onlineUsers: {},
    access: false,
    delOrCancel: '',
    broadcastStudentsList: [],
    currentDate: '',
    currentDate: '',
    getModes: {},
    teacherSearch: '',
    classFilter: [],
    subFilter: [],
    isJoinLoader: false,
    studentAttendanceData: [],
    subjectAttendanceData: {},
    selectedStudents: {},
    // Minutes needed to count as present for the class currently open; null until
    // /attendancev2/student-list resolves it, or if it cannot be worked out at all.
    attendanceThresholdMins: null,
    isAttendanceModified: false,
    checkboxState: false,
    studentListLoading: false,
    selectedId: null,
    presentStudents: [],
    cardData: {},
    initialSummary: {},
    teacherDate: {},
    pageToggle: '1',
    activeClass: {},
    conferenceJoinLoader: false,
    studentStandardFilters: [],
    recordCount: 0,
    liveStreamUrl: null,
    subsAlertData: {},
    subscriptionModal: false,
    drawerValue: '',
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_SUBJECT:
            return {
                ...state,
                subId: action.subId
            }
        case GET_SUB_LIST:
            return {
                ...state,
                subList: [...action.subList]
            }
        case GET_CLASS_LIST:
            return {
                ...state,
                classList: [...action.classList]
            }
        case GET_TEACHER_LIST:
            return {
                ...state,
                teacherList: [...action.teacherList]
            }
        case SET_TEACHER:
            return {
                ...state,
                teacherId: action.teacherId
            }
        case SET_START_DATE:
            return {
                ...state,
                startDate: action.date
            }
        case SET_END_DATE:
            return {
                ...state,
                endDate: action.enddate
            }
        case SET_START_TIME:
            return {
                ...state,
                startTime: action.time
            }
        case SET_END_TIME:
            return {
                ...state,
                endTime: action.time
            }
        case SET_WEEKDAYS:
            return {
                ...state,
                weekdays: [...action.week]
            }
        case SET_MODE:
            return {
                ...state,
                mode: action.mode
            }
        case SET_CLASS:
            return {
                ...state,
                classId: [...action.classId]
            }
        case GET_SCHEDULE_LIST:
            return {
                ...state,
                scheduleList: action.schedule
            }
        case GET_SUMMARY_DATA: {
            const incoming = Array.isArray(action.summaryData) ? action.summaryData : []
            // Hand back the SAME array when the payload hasn't actually changed. The
            // summary is refetched on a schedule of its own (page mount, and every
            // apicall:scheduleHome emit from anywhere on the page), and those refetches
            // usually return exactly what is already on screen - but a fresh [...copy]
            // is a new reference every time, which re-renders the graph and makes
            // @ant-design/charts repaint the canvas for no reason. Same payload, same
            // reference, no redraw (BarGraph.js is React.memo'd on exactly this prop).
            if (
                state.summaryDataList &&
                state.summaryDataList.length === incoming.length &&
                JSON.stringify(state.summaryDataList) === JSON.stringify(incoming)
            ) {
                return state
            }
            return {
                ...state,
                summaryDataList: [...incoming]
            }
        }
        case GET_TIMETABLE_DATA:
            return {
                ...state,
                timetableDataList: action.timetableData
            }
        case GET_STD_LIST_FILTER:
            return {
                ...state,
                stdListFilter: [...action.stdListFilter]
            }
        case SET_STD_FILTER:
            return {
                ...state,
                stdIdFilter: action.std
            }
        case GET_TODAY_ACTIVITIES_DATA:
            return {
                ...state,
                todayActivities: action.data
            }
        case GET_SUB_LIST_FILTER:
            return {
                ...state,
                subListFilter: [...action.sub]
            }
        case SET_SCHEDULE_ID:
            return {
                ...state,
                scheduleId: action.id
            }
        case SET_SCHEDULE_TIMETABLE:
            return {
                ...state,
                timetableItem: action.item
            }
        case SET_MONTH_OR_WEEK:
            return {
                ...state,
                isMonthOrWeek: action.isMonthOrWeek
            }
        case SET_START_DATE_SCHEDULE:
            return {
                ...state,
                startDateSummary: action.date
            }
        case SET_END_DATE_SCHEDULE:
            return {
                ...state,
                endDateSummary: action.date
            }
        case SET_TAB_TYPE:
            return {
                ...state,
                tabType: action.tab
            }
        case SET_STD_FILTER_TIMETABLE:
            return {
                ...state,
                stdTimetable: action.std
            }
        case UPDATE_ERROR:
            return {
                ...state,
                errorMessage: action.error
            }
        case SET_BROADCAST_SELECTED_CLASSROOM:
            return {
                ...state,
                broadcastSelectedClass: action.newClass
            }
        case SET_ROOM_IDS:
            return {
                ...state,
                roomIds: action.roomIds
            }
        case GET_ONLINE_USER:
            return {
                ...state,
                onlineUsers: action.users
            }
        case SET_ACCESS:
            return {
                ...state,
                access: action.bool
            }
        case SET_DEL_OR_CANCEL:
            return {
                ...state,
                delOrCancel: action.delOrCancel
            }

        case UPDATE_BROADCAST_STUDENT_LIST:
            let newList = [];
            for (let i = 0; i < action.data.length; i++) {
                newList.push({
                    ...action.data[i],
                    isStudent: true
                })
            }
            return {
                ...state,
                broadcastStudentsList: newList
            }

        case SET_CURRENT_DATE:
            return {
                ...state,
                currentDate: action.currentDate
            }
        case GET_MODES:
            return {
                ...state,
                getModes: action.modes
            }
        case SET_TEACHER_FILTER:
            return {
                ...state,
                teacherSearch: action.teacher
            }
        case SET_CLASS_FILTER:
            return {
                ...state,
                classFilter: [...action.classes]
            }
        case SET_SUB_FILTER:
            return {
                ...state,
                subFilter: [...action.sub]
            }

        case SET_JOIN_LOADER:
            return {
                ...state,
                isJoinLoader: action.bool
            }

        // schedule attendance

        case SET_STUDENT_DATA:
            // Deduplicate incoming student list by stable student key before storing
            const dedupeStudents = (() => {
                const list = action.value || []
                const map = new Map()
                list.forEach(item => {
                    if (!item) return
                    const key = (item.studentId !== undefined && item.studentId !== null) ? item.studentId :
                        (item.id !== undefined && item.id !== null) ? item.id :
                            (item.student && item.student.id !== undefined && item.student.id !== null) ? item.student.id :
                                (item.student_id !== undefined && item.student_id !== null) ? item.student_id : null
                    const strKey = key !== null ? String(key) : `${item.name || ''}-${item.rollNo || ''}-${item.image || ''}`
                    if (!map.has(strKey)) map.set(strKey, item)
                })
                return Array.from(map.values())
            })()
            return {
                ...state,
                studentAttendanceData: dedupeStudents
            }

        case SET_SUBJECT_DATA:
            return {
                ...state,
                subjectAttendanceData: action.value
            }


        case SET_SELECTED_STUDENTS:
            let tem = { ...state.selectedStudents }
            tem[action.id] = tem[action.id] === undefined ? true : tem[action.id] === true ? false : true
            return {
                ...state,
                selectedStudents: tem,
                isAttendanceModified: true,
                checkboxState: Object.keys(tem).length > 0 && Object.values(tem).every((item) => (item === true))
            }

        case SET_SELECTED_STUDENTS_CLEAR:
            return {
                ...state,
                selectedStudents: {},
                isAttendanceModified: false,
                checkboxState: false
            }

        case SET_CHECKBOX_STATE:
            // let tbool = false;
            // if (!state.checkboxState) {
            //     tbool = true;
            // }
            return {
                ...state,
                checkboxState: action.bool
            }

        case SET_STUDENT_LIST_LOADING:
            return {
                ...state,
                studentListLoading: action.bool
            }

        case SET_SELECT_ALL:
            let temp = {};
            const newCheckboxState = !state.checkboxState;
            state.studentAttendanceData.forEach(item => {
                temp[item.studentId] = newCheckboxState
            });
            return {
                ...state,
                selectedStudents: temp,
                isAttendanceModified: true,
                checkboxState: newCheckboxState
            }

        case SET_ATTENDANCE_THRESHOLD:
            return {
                ...state,
                attendanceThresholdMins: action.thresholdMins ?? null
            }

        case SET_ALL_FALSE:
            let temp1 = {};
            // The API's own present/absent call wins. Only when it has not made one do
            // we fall back to the duration, against the class's configured requirement.
            const seedThreshold = action.thresholdMins;
            state.studentAttendanceData.forEach(item => {
                const itemMode = String(item.mode || item.scheduleMode || action.mode || '').toLowerCase();
                const rawDur = item.duration ?? item.totalDuration ?? item.attendanceDuration ?? item.student?.duration ?? item.student?.totalDuration ?? item.student?.attendanceDuration;
                const durationNum = parseInt(rawDur || 0, 10);
                const itemPresent = item.isPresent ?? item.student?.isPresent;
                const statusStr = String(item.status || item.student?.status || '').toLowerCase();
                const isExplicitPresent = itemPresent === true || statusStr === 'present';
                const isExplicitAbsent = itemPresent === false || statusStr === 'absent';

                if (itemMode === 'others' || itemMode === 'other') {
                    if (durationNum > 0) {
                        temp1[item.studentId] = isExplicitPresent
                            || (!isExplicitAbsent
                                && Number.isFinite(seedThreshold)
                                && durationNum >= seedThreshold);
                        return;
                    }
                    temp1[item.studentId] = isExplicitPresent;
                    return;
                }
                temp1[item.studentId] = isExplicitPresent
                    || (!isExplicitAbsent
                        && Number.isFinite(seedThreshold)
                        && durationNum >= seedThreshold);
            });
            return {
                ...state,
                isAttendanceModified: false,
                selectedStudents: temp1
            }

        case SET_SELECTED_ID:
            return {
                ...state,
                selectedId: action.id
            }

        case SET_PRESENT_STUDENTS:
            const output = [];
            Object.keys(state.selectedStudents).forEach(key => {
                if (state.selectedStudents[key]) {
                    output.push(key);
                }
            })
            return {
                ...state,
                presentStudents: action.id === null ? [] : output
            }

        case SET_CARD_DATA:
            return {
                ...state,
                cardData: action.value
            }

        case SET_INITIAL_SUMMARY:
            return {
                ...state,
                initialSummary: action.value
            }

        case SET_TEACHER_DATE:

            let teacherDateObj = { ...state.teacherDate };
            if (action.key === 'momentDate') {
                teacherDateObj.moment = action.value;
            }
            else if (action.key === 'stringDate') {
                teacherDateObj.date = action.value;
            } else {
                null
            }

            return {
                ...state,
                teacherDate: { ...teacherDateObj }
            }

        case SET_PAGE_TOGGLE:
            return {
                ...state,
                pageToggle: action.value
            }

        case FETCH_SUBSALERT_DATA:
            return {
                ...state,
                subsAlertData: action.res
            }
        case UPDATE_ACTIVE_CLASS:
            return {
                ...state,
                activeClass: action.value,
            };
        case SET_CONFERENCE_JOIN_LOADER:
            return {
                ...state,
                conferenceJoinLoader: action.bool
            }

        case STUDENT_STANDARD_FILTER:
            return {
                ...state,
                studentStandardFilters: action.res
            }
        case SET_RECORD_COUNT:
            return {
                ...state,
                recordCount: action.val
            }
        case SET_LIVE_STREAM_URL:
            return {
                ...state,
                liveStreamUrl: action.val
            }
        case SET_SUBSCRIPTION_MODAL:
            return {
                ...state,
                subscriptionModal: action.res
            }

        case DRAWER_BOOLEAN_STATE:
            return {
                ...state,
                drawerValue: action.value
            }
        default:
            return state

    }
}

export default reducer